// The count of failed actions will be polled. The nature of these actions means there's no need to poll to regularly.
export const REFRESH_INTERVAL_MINUTES = 5;

// To avoid gigantic numbers of failed actions showing, cut at this point.
export const MAXIMUM_INDICATOR = 99;
